{
  "el": {
    "marketplace_partner": {
      "contact_me": {
        "button": "Επικοινωνία μαζί μου",
        "failure": "Παρουσιάστηκε ένα απρόσμενο σφάλμα.",
        "success": "Θα επικοινωνήσουμε μαζί σου σύντομα."
      }
    }
  }
}
